import React from 'react'
import { MimaButton, MimaText } from '../components'

const RoughSketch = () => {
  return (
    <div style={{padding: "5rem"}}>
        <MimaText labelTitle="Testing that the label works">
            Test Text
        </MimaText>

        <MimaButton title="On God" labelTitle="In case" labelColor="var(--color-error)" mt={4}/>
    </div>
  )
}

export default RoughSketch